import { get, isBoolean, isNumber, isDate, isEmpty, isObject } from 'lodash';

type ReturnTypeItemValue<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  D extends Record<string, any>,
  P extends keyof D,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  F extends (item: D[P]) => any,
  DF,
> = F extends (item: D[P]) => D[P] ? D[P] | DF : ReturnType<F> | DF;

export const getItemValue = <
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  D extends Record<string, any>,
  P extends keyof D,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  F extends (item: D[P]) => any,
  DF extends
    | string
    | number
    | boolean
    | null
    | undefined
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    | any[]
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    | Record<string, any> = null,
>(
  data: D,
  pathToFind: P,
  formatter?: F,
  defaultValue = null as DF,
): ReturnTypeItemValue<D, P, F, DF> => {
  const item = get(data, pathToFind);

  if (
    !isBoolean(item) &&
    !isNumber(item) &&
    !isDate(item) &&
    !isObject(item) &&
    isEmpty(item)
  ) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return defaultValue as any;
  }

  if (formatter) return formatter(item);

  return item;
};
